<template>
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 1460px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h2>Descricao do Log SQL</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>

                <div class="modal-body">
                    <pre class="descricao-content">{{ descricaoExibicao }}</pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Options({
        name: "VisualizarSql",
    })
    export default class VisualizarSql extends Vue {
        @Prop() readonly modal!: string;
        @Prop() readonly descricao!: string;

        get descricaoExibicao(): string {
            return this.descricao && this.descricao.trim() !== "" ? this.descricao : "Sem descricao informada.";
        }
    }
</script>

<style scoped>
    .descricao-content {
        margin: 0;
        padding: 20px;
        border: 1px solid #e5edf6;
        border-radius: 16px;
        background: #f8fafc;
        color: #102542;
        font-size: 0.95rem;
        line-height: 1.6;
        white-space: pre-wrap;
        word-break: break-word;
        max-height: 65vh;
        overflow: auto;
    }
</style>
